import api from ".";

export const getCustomers = (params) => api.get(`/customers`, { params });

export const getArchivedCustomers = (params) => api.get("/customers/archived", { params });

export const getCustomerDetails = (uuid) => api.get(`/customers/${uuid}/view`);

export const archiveCustomer = ({ uuid }) => api.patch(`/customers/${uuid}/archive`);

export const unArchiveCustomer = ({ uuid }) => api.patch(`/customers/${uuid}/unarchive`);

export const createCustomer = (data) => api.post("/customers/store", data);

export const uploadCustomers = (data) => api.post("/customers/upload", data, { headers: { "Content-Type": "multipart/form-data" } });

export const updateCustomer = ({ uuid, ...data }) => api.patch(`/customers/${uuid}/update`, data);

export const generateVirtualAccount = ({ uuid, ...data }) => api.post(`/customers/${uuid}/virtual-account`, data);
